import * as moment from 'moment';

const frequencyText = {
  billedWhen: {
    MONTHLY: 'settings:account:plan:billedMonthly',
    YEARLY: 'settings:account:plan:billedYearly',
  },
  perWhen: {
    MONTHLY: 'settings:account:plan:perMonth',
    YEARLY: 'settings:account:plan:perYear',
  },
  sliderOptions: {
    lowercase: {
      MONTHLY: 'settings:plans:adjust:pro:slider:frequencyOptions:lowercase:month',
      YEARLY: 'settings:plans:adjust:pro:slider:frequencyOptions:lowercase:year',
    },
    uppercase: {
      MONTHLY: 'settings:plans:adjust:pro:slider:frequencyOptions:uppercase:month',
      YEARLY: 'settings:plans:adjust:pro:slider:frequencyOptions:uppercase:year',
    },
  },
};

// Incomplete, fill in as necessary
type JSONPlan = {
  display_name: string;
  frequency: string;
  is_free_trial: boolean;
  is_full_access: boolean;
  is_pro: boolean;
  is_subscription: boolean;
  name: string;
  number_of_labels_included: number;
  number_of_seats: number;
  original_subscription_price: string;
  subscription_price: string;
};

type Plan = {
  billingFrequency: string;
  displayName: string;
  isFreeTrial: boolean;
  isFullAccess: boolean;
  // TODO: Deprecate isPro
  isPro: boolean;
  name: string;
  numberOfLabelsIncluded: number;
  numberOfSeats: number;
  originalSubscriptionPrice: number;
  subscriptionPrice: number;
};

export type JSONUserPlan = {
  end_date: Maybe<string>;
  next_billing_date: Maybe<string>;
  plan: JSONPlan;
  start_date: string;
};

type UserPlan = {
  endDate: Maybe<moment.Moment>;
  nextBillingDate: Maybe<moment.Moment>;
  plan: Plan;
  startDate: moment.Moment;
};

const fromJSON = (jsonPlan: JSONPlan): Plan => ({
  billingFrequency: jsonPlan.frequency,
  displayName: jsonPlan.display_name,
  isFreeTrial: jsonPlan.is_free_trial,
  isFullAccess: jsonPlan.is_full_access,
  isPro: jsonPlan.is_pro,
  name: jsonPlan.name,
  numberOfLabelsIncluded: jsonPlan.number_of_labels_included,
  numberOfSeats: jsonPlan.number_of_seats,
  originalSubscriptionPrice: Number(jsonPlan.original_subscription_price),
  subscriptionPrice: Number(jsonPlan.subscription_price),
});

const userPlanFromJSON = (jsonUserPlan: JSONUserPlan): UserPlan => ({
  endDate: jsonUserPlan.end_date ? moment(jsonUserPlan.end_date) : null,
  nextBillingDate: jsonUserPlan.next_billing_date ? moment(jsonUserPlan.next_billing_date) : null,
  plan: fromJSON(jsonUserPlan.plan),
  startDate: moment(jsonUserPlan.start_date),
});

export default Plan;

export { UserPlan, frequencyText, fromJSON, userPlanFromJSON };
